/**
 * HorsIndex — site-wide configuration.
 *
 * To activate LinkedIn (or any other social network), set the URL string below.
 * Empty string = link hidden. Schema.org sameAs is also populated when set.
 */
export const SITE = {
  url: process.env.REACT_APP_SITE_URL || "https://horsindex.com",
  domain: (process.env.REACT_APP_SITE_URL || "https://horsindex.com").replace(/^https?:\/\//, ""),
};

export const SOCIAL = {
  linkedin: "", // ex. "https://www.linkedin.com/company/horsindex" — leave empty to hide
  twitter: "",  // ex. "https://twitter.com/HorsIndex" — leave empty to hide
};

export const SOCIAL_LIST = Object.entries(SOCIAL)
  .filter(([, url]) => Boolean(url))
  .map(([key, url]) => ({ key, url }));
